import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, IconButton, Stack, useTheme, useMediaQuery } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getApiUrl } from '../config/api';

const FeeStructuresPage = () => {
    const navigate = useNavigate();
    const [structures, setStructures] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        fetchStructures();
    }, []);

    const fetchStructures = async () => {
        try {
            const userInfo = localStorage.getItem('userInfo');
            const token = userInfo ? JSON.parse(userInfo).token : null;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.get(getApiUrl('fees/structures'), config);
            setStructures(data);
        } catch (error) {
            console.error('Error fetching fee structures:', error);
        }
    };

    const handleDelete = async (id: string) => {
        if (window.confirm('Are you sure you want to delete this fee structure?')) {
            try {
                const userInfo = localStorage.getItem('userInfo');
                const token = userInfo ? JSON.parse(userInfo).token : null;
                await axios.delete(getApiUrl(`fees/structures/${id}`), {
                    headers: { Authorization: `Bearer ${token}` }
                });
                fetchStructures();
            } catch (error) {
                console.error('Error deleting structure:', error);
            }
        }
    };

    return (
        <Box sx={{ p: isMobile ? 2 : 0 }}>
            <Stack direction={isMobile ? "column" : "row"} justifyContent="space-between" alignItems={isMobile ? "flex-start" : "center"} mb={4} spacing={2}>
                <Typography variant={isMobile ? "h5" : "h4"} fontWeight={700} color="#1a237e">Fee Structures</Typography>
                <Stack direction={isSmallMobile ? "column" : "row"} spacing={2} sx={{ width: isSmallMobile ? '100%' : 'auto' }}>
                    <Button
                        variant="outlined"
                        fullWidth={isSmallMobile}
                        startIcon={<PlayArrowIcon />}
                        onClick={() => navigate('/dashboard/fees/billing')}
                        sx={{ fontWeight: 'bold' }}
                    >
                        Run Auto-Billing
                    </Button>
                    <Button
                        variant="contained"
                        fullWidth={isSmallMobile}
                        startIcon={<AddIcon />}
                        onClick={() => navigate('/dashboard/fees/create')}
                        sx={{ bgcolor: '#ffab00', color: 'black', fontWeight: 'bold' }}
                    >
                        Create New
                    </Button>
                </Stack>
            </Stack>

            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: '12px', border: '1px solid #f0f0f0', overflow: 'hidden' }}>
                <TableContainer sx={{ overflowX: 'auto' }}>
                    <Table sx={{ minWidth: isMobile ? 700 : 'auto' }}>
                        <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Grade</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Term</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Year</TableCell>
                                <TableCell sx={{ fontWeight: 700 }} align="right">Total Amount</TableCell>
                                <TableCell sx={{ fontWeight: 700 }} align="right">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {structures.map((row: any) => (
                                <TableRow key={row.id} hover>
                                    <TableCell sx={{ fontWeight: 600 }}>{row.name}</TableCell>
                                    <TableCell>
                                        <Chip label={row.grade} size="small" sx={{ bgcolor: '#e3f2fd', color: '#1565c0', fontWeight: 600 }} />
                                    </TableCell>
                                    <TableCell>{row.term}</TableCell>
                                    <TableCell>{row.academicYear}</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                        ${Number(row.totalAmount).toLocaleString()}
                                    </TableCell>
                                    <TableCell align="right">
                                        <IconButton size="small" onClick={() => handleDelete(row.id)} color="error">
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {structures.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.secondary' }}>
                                        No fee structures defined yet.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </TableContainer>
        </Box>
    );
};

export default FeeStructuresPage;
